// creates andwebb global object for custom event emitting
// uses package mitt
import mitt from 'mitt'

const $mitt = mitt()

export default $mitt
